import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-intro-module-border",
  "use": "icon-intro-module-border-usage",
  "viewBox": "0 0 1360 610",
  "content": "<symbol viewBox=\"0 0 1360 610\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-intro-module-border\">\n<rect x=\"0.5\" y=\"0.5\" width=\"1359\" height=\"609\" rx=\"19.5\" stroke=\"url(#icon-intro-module-border_paint0_linear_533_1279)\" stroke-width=\"2px\" stroke-opacity=\"0.6\" />\n<defs>\n<linearGradient id=\"icon-intro-module-border_paint0_linear_533_1279\" x1=\"680\" y1=\"0\" x2=\"680\" y2=\"610\" gradientUnits=\"userSpaceOnUse\">\n<stop stop-color=\"#FFE6D3\" stop-opacity=\"0.66\" />\n<stop offset=\"1\" stop-color=\"#FFF3D3\" stop-opacity=\"0\" />\n</linearGradient>\n</defs>\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/intro-module-border.svg
// module id = 1dJV
// module chunks = 64